import React, { FC, useCallback, useState } from 'react'

import SettingsIcon from '@mui/icons-material/Settings'
import { IconButton, Stack, Typography, useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CollapseIcon } from '../../assets/icons/collapse-all.svg'
import { ReactComponent as ExpandIcon } from '../../assets/icons/expand-all.svg'
import { SelectColumnsModal } from '../../components/Table/SelectColumnsModal'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { useIsMobile } from '../../utils/useIsMobile'

import { expandAll, collapseAll } from './DailyStatsReducer'

const buttonStyles = {
  // padding: 0,
  justifyContent: 'flex-start',
}

export const DailyStatsHeader: FC = () => {
  const { t } = useTranslation()
  const { spacing, palette } = useTheme()
  const isMobile = useIsMobile('sm')

  const [showColumnsModal, setShowColumnsModal] = useState(false)
  const dispatch = useAppDispatch()
  const { dailyStatsData } = useAppSelector((state) => state.dailyStats)

  const handleShowAll = useCallback(() => dispatch(expandAll()), [])
  const handleCollapseAll = useCallback(() => dispatch(collapseAll()), [])
  const handleToggleModal = () => {
    setShowColumnsModal((prev) => !prev)
  }

  const dailyStatsDataArray = Object.entries(dailyStatsData)

  return (
    <>
      <Stack
        display="flex"
        direction={'row'}
        spacing={2}
        alignItems="center"
        width={'100%'}
        justifyContent={'space-between'}
        padding={spacing(2, 3)}
        bgcolor={palette.background.paper}
      >
        {!!dailyStatsDataArray.length && (
          <>
            <Stack direction={'row'} alignItems={'center'} spacing={2}>
              <IconButton disableRipple onClick={handleShowAll} sx={buttonStyles}>
                <ExpandIcon />
                <Typography variant={'body1'} ml={spacing(0.5)}>
                  {isMobile
                    ? t('dailyStatsPage.header.expand', 'Expand')
                    : t('dailyStatsPage.header.expandAll', 'Expand all')}
                </Typography>
              </IconButton>
              <IconButton disableRipple onClick={handleCollapseAll} sx={buttonStyles}>
                <CollapseIcon />
                <Typography variant={'body1'} ml={spacing(0.5)}>
                  {isMobile
                    ? t('dailyStatsPage.header.collapse', 'Collapse')
                    : t('dailyStatsPage.header.collapseAll', 'Collapse all')}
                </Typography>
              </IconButton>
            </Stack>
            <Box
              display="flex"
              justifyContent="center"
              alignItems={'center'}
              gap={spacing(0.5)}
              onClick={handleToggleModal}
              sx={{
                cursor: 'pointer',
                color: palette.grey[700],
                '&:hover': {
                  color: palette.grey[900],
                },
                marginLeft: 'auto',
              }}
            >
              <SettingsIcon color="inherit" />
              {!isMobile && (
                <Typography variant="body1" fontWeight="bold">
                  {t('selectColumnsModal.title', 'Select columns')}
                </Typography>
              )}
            </Box>
          </>
        )}
      </Stack>
      <SelectColumnsModal isOpen={showColumnsModal} closeModal={handleToggleModal} />
    </>
  )
}
